import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from "react";
var _React$createContext = /*#__PURE__*/React.createContext({
    isOpen: true,
    onExited: function onExited() {
      return undefined;
    }
  }),
  Consumer = _React$createContext.Consumer,
  Provider = _React$createContext.Provider;

// checks if children exist and are truthy
var hasChildren = function hasChildren(children) {
  return React.Children.count(children) > 0 && React.Children.map(children || [], function (child) {
    return !!child;
  }).filter(Boolean).length > 0;
};
export var ModalTransition = function ModalTransition(_ref) {
  var children = _ref.children;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    previousChildrenForUnmount = _useState2[0],
    setPreviousChildrenForUnmount = _useState2[1];

  /**
   * This effect's only job is to track children at each render.
   * When the component unmounts i.e. its children are unmounted, it will
   * set the most recently-tracked children as the current children.
   * This allows the Modal to retain its contents for the duration of the animation,
   * after which onExited will be called and we set that cache to null.
   */
  useEffect(function () {
    var exiting = hasChildren(previousChildrenForUnmount) && !hasChildren(children);
    setPreviousChildrenForUnmount(exiting ? previousChildrenForUnmount : children);
  }, [previousChildrenForUnmount, children]);
  var onExited = function onExited() {
    setPreviousChildrenForUnmount(null);
  };
  return /*#__PURE__*/React.createElement(Provider, {
    value: {
      onExited: onExited,
      isOpen: hasChildren(children)
    }
  }, children || previousChildrenForUnmount);
};
export var ModalTransitionConsumer = Consumer;
//# sourceMappingURL=ModalTransition.js.map